import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import moment from "moment";
import PrintHeader from "../General/PrintHeader";
import Page from "../General/Page";
import RightsCheck from "../General/RightsCheck";

const levelLabels = {
  0: "All Levels",
  1: "1st Level",
  2: "2nd Level",
  3: "3rd Level",
};

const PrintTrialBalanceLevelWise = () => {
  const [AccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID] = useState(localStorage.getItem("ID"));
  const [MemberType] = useState(localStorage.getItem("MemberType"));

  const [loading, setLoading] = useState(true);
  const [listOfLedger, setLedger] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [openingDebitTotal, setOpeningDebitTotal] = useState("");
  const [openingCreditTotal, setOpeningCreditTotal] = useState("");
  const [currentDebitTotal, setCurrentDebitTotal] = useState("");
  const [currentCreditTotal, setCurrentCreditTotal] = useState("");
  const [closingDebitTotal, setClosingDebitTotal] = useState("");
  const [closingCreditTotal, setClosingCreditTotal] = useState("");
  const [filterLabel, setFilterLabel] = useState("");

  useEffect(() => {
    document.title = "Print Trial Balance Level Wise";

    const params = new URLSearchParams(window.location.search);
    const fYear = parseInt(params.get("FYear") || "0", 10) || 0;
    const startDate = params.get("StartDate") || "";
    const endDate = params.get("EndDate") || "";
    const accountLevel = parseInt(params.get("AccountLevel") || "0", 10) || 0;
    const showZero = params.get("ShowZeroAccounts") === "1";

    const parts = [`Year ${fYear}`, levelLabels[accountLevel] || `Level ${accountLevel}`];
    if (startDate) {
      parts.push(`From ${moment(startDate).format("DD/MM/YYYY")}`);
    }
    if (endDate) {
      parts.push(`To ${moment(endDate).format("DD/MM/YYYY")}`);
    }
    if (!showZero) {
      parts.push("Zero accounts hidden");
    }
    setFilterLabel(parts.join(" · "));

    if (!fYear || !startDate || !endDate) {
      setLoading(false);
      return;
    }

    axios({
      method: "post",
      url: config.base_url + "Accounts/GetTrialBalance",
      headers: { "Content-Type": "application/json" },
      data: {
        AccessKey,
        UserID,
        MemberType,
        pageNo: 1,
        pageSize: 10000,
        FYear: fYear,
        StartDate: startDate,
        EndDate: endDate,
        AccountLevel: accountLevel,
        ShowZeroAccounts: showZero,
      },
    })
      .then((response) => {
        if (response.data?.status_code === 1 && Array.isArray(response.data.ListofRecords)) {
          setLedger(response.data.ListofRecords);
          setTotalRecords(response.data.totalRecords || 0);
          setOpeningDebitTotal(response.data.OpeningDebitTotal || "");
          setOpeningCreditTotal(response.data.OpeningCreditTotal || "");
          setCurrentDebitTotal(response.data.CurrentDebitTotal || "");
          setCurrentCreditTotal(response.data.CurrentCreditTotal || "");
          setClosingDebitTotal(response.data.ClosingDebitTotal || "");
          setClosingCreditTotal(response.data.ClosingCreditTotal || "");
        } else {
          setLedger([]);
          setTotalRecords(0);
        }
        setLoading(false);
      })
      .catch(() => {
        setLedger([]);
        setLoading(false);
      });
  }, [AccessKey, UserID, MemberType]);

  const renderLedger = () => {
    if (listOfLedger.length > 0) {
      let count = 1;
      return listOfLedger.map((item, index) => (
        <tr key={index}>
          <td>{count++}</td>
          <td>{item.Selected_Account?.Account_code}</td>
          <td>{item.Selected_Account?.Account_desc}</td>
          <td className="text-end">{item.OpeningDebit}</td>
          <td className="text-end">{item.OpeningCredit}</td>
          <td className="text-end">{item.CurrentDebit}</td>
          <td className="text-end">{item.CurrentCredit}</td>
          <td className="text-end">{item.ClosingDebit}</td>
          <td className="text-end">{item.ClosingCredit}</td>
        </tr>
      ));
    }

    return (
      <tr>
        <td colSpan={9}>
          <h4 className="mt-3" style={{ fontSize: "15px", color: "rgba(0,0,0,0.6)" }}>
            No Data Found
          </h4>
        </td>
      </tr>
    );
  };

  return (
    <>
      <RightsCheck />
      <Page orientation="landscape" size="a4">
        <PrintHeader title="Trial Balance Level Wise" />
        {filterLabel ? (
          <p className="small mb-2" style={{ fontSize: "10pt" }}>
            {filterLabel}
          </p>
        ) : null}
        <table className="table table-sm table-bordered table-print">
          <thead>
            <tr>
              <th colSpan={9} className="text-end">
                Total records: {totalRecords}
              </th>
            </tr>
            <tr>
              <th>Sr#</th>
              <th>Account Code</th>
              <th>Account Name</th>
              <th colSpan={2} className="text-center">Opening</th>
              <th colSpan={2} className="text-center">Current</th>
              <th colSpan={2} className="text-center">Closing</th>
            </tr>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th className="text-center">Debit</th>
              <th className="text-center">Credit</th>
              <th className="text-center">Debit</th>
              <th className="text-center">Credit</th>
              <th className="text-center">Debit</th>
              <th className="text-center">Credit</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan={9}>
                  <Spinner animation="border" role="status" />
                </td>
              </tr>
            ) : (
              <>
                {renderLedger()}
                {listOfLedger.length > 0 && (
                  <tr>
                    <th colSpan={3} className="text-end">
                      Grand Total
                    </th>
                    <th className="text-end">{openingDebitTotal}</th>
                    <th className="text-end">{openingCreditTotal}</th>
                    <th className="text-end">{currentDebitTotal}</th>
                    <th className="text-end">{currentCreditTotal}</th>
                    <th className="text-end">{closingDebitTotal}</th>
                    <th className="text-end">{closingCreditTotal}</th>
                  </tr>
                )}
              </>
            )}
          </tbody>
        </table>
      </Page>
    </>
  );
};

export default PrintTrialBalanceLevelWise;
